import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class TeamId extends PrimitiveValueObject<string> {
  static create(value: string): TeamId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new TeamId(value);
  }
}
